import { render } from "./additional-earnings.vue?vue&type=template&id=db76c32a&scoped=true"
import script from "./additional-earnings.vue?vue&type=script&lang=js"
export * from "./additional-earnings.vue?vue&type=script&lang=js"

import "./additional-earnings.vue?vue&type=style&index=0&id=db76c32a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db76c32a"]])

export default __exports__